module.exports = __webpack_public_path__ + "img/H000120_rottoenapple.aaa5b462.png";